import * as parseColor from 'color';
export function withoutOpacity(value) {
    return parseColor(value)
        .alpha(1)
        .rgb()
        .string();
}
export function withHex(value) {
    return parseColor(value).hex();
}
//# sourceMappingURL=color.js.map